import PublicInterviewSuccessPage from './public-success';
import PrivateInterviewSuccess from './private-success';
import useGlobalState from '../../../utils/global-state';

export const InterviewSuccess = () => {
  const [{ userData }] = useGlobalState();
  if (userData) return <PrivateInterviewSuccess />;
  return <PublicInterviewSuccessPage />;
};
